import { render, staticRenderFns } from "./UserTransactionHistory.vue?vue&type=template&id=359854ac&scoped=true"
import script from "./UserTransactionHistory.vue?vue&type=script&lang=ts"
export * from "./UserTransactionHistory.vue?vue&type=script&lang=ts"
import style0 from "./UserTransactionHistory.vue?vue&type=style&index=0&id=359854ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359854ac",
  null
  
)

export default component.exports